import { useAuth0 } from '@auth0/auth0-react';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

const IdpLogin = () => {
    const { loginWithRedirect } = useAuth0();
    let [searchParams] = useSearchParams();

    useEffect(() => {
        const redirectToAuthorize = async () => {
            const inviteMatches = searchParams.get('invitation');
            const orgMatches = searchParams.get('organization');
            if (inviteMatches && orgMatches) {
                loginWithRedirect({
                authorizationParams: {
                    organization: orgMatches,
                    invitation: inviteMatches,
                }
                });
            } else {
                await loginWithRedirect();
                // Optionally, handle error or missing connection.
            }
        };

        redirectToAuthorize();
    }, [loginWithRedirect, searchParams]);

    // You can return null or a loading indicator while the redirection happens
    return null;
};

export default IdpLogin;
